import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function SuperOrders() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("");
  const [mode, setMode] = useState("");

  useEffect(() => {
    const params = {};
    if (status) params.status = status;
    if (mode) params.delivery_mode = mode;
    api.get("/admin/orders", { params }).then((r) => setOrders(r.data));
  }, [status, mode]);

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-5">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tight">Order Control Center</h1>
        <p className="text-gray-600 text-sm">{orders.length} orders</p>
      </div>

      <div className="flex flex-wrap gap-3">
        <select className="qd-input !w-auto" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="super-orders-status-filter">
          <option value="">All statuses</option>
          <option value="new">New</option>
          <option value="accepted">Accepted</option>
          <option value="packed">Packed</option>
          <option value="out_for_delivery">Out for delivery</option>
          <option value="delivered">Delivered</option>
          <option value="cancelled">Cancelled</option>
        </select>
        <select className="qd-input !w-auto" value={mode} onChange={(e) => setMode(e.target.value)} data-testid="super-orders-mode-filter">
          <option value="">All delivery modes</option>
          <option value="self">Self</option>
          <option value="borzo">Borzo</option>
          <option value="porter">Porter</option>
          <option value="shadowfax">Shadowfax</option>
        </select>
      </div>

      <div className="qd-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500 border-b">
              <th className="p-3 font-semibold">Order</th>
              <th className="p-3 font-semibold">Customer</th>
              <th className="p-3 font-semibold">Total</th>
              <th className="p-3 font-semibold">Status</th>
              <th className="p-3 font-semibold">Mode</th>
              <th className="p-3 font-semibold">ETA</th>
              <th className="p-3 font-semibold">Pincode</th>
              <th className="p-3 font-semibold">Payment</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-gray-50">
                <td className="p-3 font-mono text-xs">{o.order_number}</td>
                <td className="p-3">{o.customer_name}</td>
                <td className="p-3 font-bold">₹{o.total}</td>
                <td className="p-3 capitalize text-xs">{o.status.replace(/_/g, " ")}</td>
                <td className="p-3 capitalize">{o.delivery_mode}</td>
                <td className="p-3">{o.eta_minutes} min</td>
                <td className="p-3 font-mono text-xs">{o.pincode}</td>
                <td className="p-3 uppercase text-xs">{o.payment_mode}</td>
              </tr>
            ))}
            {orders.length === 0 && (
              <tr><td colSpan="8" className="p-8 text-center text-gray-500">No orders</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
